import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b9208a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmCsvAlmunus",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body content mx-0 p-0" }
const _hoisted_8 = { class: "px-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-0 mx-0 pt-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fw-bold mb-1" }, [
    /*#__PURE__*/_createTextVNode("選択したユーザの登録情報をダウンロードします。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("件数によっては時間がかかる可能性がございます。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("一度に出力するユーザ数は1,000件以下にしてください。")
  ])
], -1))
const _hoisted_10 = { class: "fw-bold py-4" }
const _hoisted_11 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_12 = { class: "list-id" }
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = { class: "row mx-0 px-0 d-flex justify-content-center flex-sm-row flex-column-reverse mb-4" }
const _hoisted_15 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_16 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_17 = {
  class: "modal fade",
  id: "modalErrorCsvAlmunus",
  tabindex: "-1",
  "aria-labelledby": "modalErrorCsvAlmunus",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = {
  class: "modal-title text-center fw-bold w-100",
  id: "CsvErrorModalHeader"
}
const _hoisted_22 = { class: "text-center m-4" }
const _hoisted_23 = { class: "d-flex justify-content-center modal-footer" }

import { onMounted, PropType, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Modal } from 'bootstrap'
import { numberWithCommas } from '@/constants/common'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import communityAlumnusServices from '@/services/community-alumnus.services'
import { getMessage } from '@/constants/messageCode'
import { blobDownload } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array as PropType<Array<{ management_no: string; family_name: string; given_name: string; display_name: string }>>,
  reload: Function as PropType<() => void | undefined>,
  getListUserFailed: Function as PropType<any>,
  fileDownloadName: {
    type: String,
    default: () => 'YELLoop_',
  },
  isCandidate: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const modalError = ref()
const modalConfirm = ref()
const errorMessage = ref<string>('')

var date = new Date()
var s_date = ''
s_date += date.getFullYear()
s_date += ('0' + (date.getMonth() + 1)).slice(-2)
s_date += ('0' + date.getDate()).slice(-2)
s_date += ('0' + date.getHours()).slice(-2)
s_date += ('0' + date.getMinutes()).slice(-2)
s_date += ('0' + date.getSeconds()).slice(-2)



const statusMap: Record<string, string> = {
  leave: translate('SO10user30'),
  available: translate('OE12pause'),
}
const getItemDisplay = (item: any): string => {
  return `${item.family_name} ${item.given_name} ${statusMap[item.status] || ''} (${item.display_name})`
}

const loadingConfirm = ref(false)
const onSubmit = async (): Promise<void> => {
  const { data, reload, getListUserFailed, isCandidate } = props

  loadingConfirm.value = true
  try {
    const payloadData: any = {
      user_management_ids: data?.map((item: any) => item.management_no),
    }
    if (isCandidate) {
      payloadData.is_candidate = true
    }

    const response = await communityAlumnusServices.csvDownloadAlmuniApi({
      id: route.params?.id,
      data: payloadData,
    })

    var user_category = ''
    if (response.config.data.match(/A/)) {
      user_category = 'A'
    } else {
      user_category = 'C'
    }

    if (response.status === 200) {
      let blob = new Blob([response.data], { type: 'text/csv' })
      const fileName = props.fileDownloadName + user_category + s_date
      blobDownload(blob, fileName)
      loadingConfirm.value = false
      modalConfirm.value?.hide()
      reload()
      return
    }
    loadingConfirm.value = false
    modalConfirm.value?.hide()
    errorMessage.value = JSON.parse(await response.response?.data?.text())?.data[0]?.message_code
    modalError.value?.show()
  } catch (error) {
    loadingConfirm.value = false
    modalConfirm.value?.hide()
    modalError.value?.show()
    console.log(error)
  }
}

onMounted(() => {
  modalError.value = new Modal(document.getElementById('modalErrorCsvAlmunus'))
})
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirmCsvAlmunus'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE10titleModalCsv')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(numberWithCommas)(__props.data?.length)) + _toDisplayString(_unref(translate)('selectingUserItems')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "mb-2 d-flex align-items-center",
                        key: index
                      }, [
                        _createVNode(UserAliasIcon, { userType: 2 }),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item?.management_no), 1),
                        _createElementVNode("span", null, _toDisplayString(getItemDisplay(item)), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(Button, {
                      title: _unref(translate)('cancel'),
                      type: "secondary",
                      "data-bs-dismiss": "modal"
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(Button, {
                      title: _unref(translate)('OE10CsvDownload'),
                      type: "secondary",
                      onClick: onSubmit,
                      disabled: loadingConfirm.value,
                      loading: loadingConfirm.value
                    }, null, 8, ["title", "disabled", "loading"])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h5", _hoisted_21, _toDisplayString(_unref(translate)('OE10titleModalCsv')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(getMessage)(errorMessage.value)), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: "secondary",
              onClick: __props.reload,
              "data-bs-dismiss": "modal",
              className: "fw-bold"
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})